'use client'
import { Link, usePathname } from '@/i18n/routing'
import { IconArrowRight, IconMail } from '@tabler/icons-react'
import { useTranslations } from 'next-intl'
import { useEffect, useState } from 'react'

/* Mobil sitzt der Tab als Pille in der Reihe von FloatingActions, unten
   rechts neben der Beratung. Vorher hing er fixiert auf halber Hoehe und
   lag damit quer ueber jeder H1, auf 390px Breite belegt er rund 40
   Prozent des Schirms. Ab lg bleibt er der angeschnittene Tab am rechten
   Rand: rechte Kante gerade, kein rechter Rahmen. */
const linkClassName = `flex flex-row items-center gap-x-3 lg:gap-x-6
      rounded-3xl border p-4 shadow-2xl
      lg:fixed lg:top-[200px] lg:right-0 lg:rounded-r-none lg:border-r-0 lg:p-8 lg:shadow-none
      transition-colors text-base lg:text-lg leading-6 border-accent bg-KMRS-Darkmode hover:bg-accent z-45
      active:text-white [&:hover_svg]:text-white [&_svg]:text-accent`

const CTAContactLink = () => {
  // next-intl usePathname liefert den internen DE-Pfad-Key ohne Locale-Praefix
  // (z.B. /kontakt), sprachunabhaengig. So blendet der Guard den Button auf der
  // Kontaktseite in beiden Sprachen aus. Der i18n-Link mappt /kontakt automatisch
  // auf /en/contact (statt vorher hartcodiert /contact ohne /en -> 307).
  const pathname = usePathname()
  const t = useTranslations('contact')
  // Landingpages mit eigenem Anfrageformular (#anfrage) schicken die Pille zum
  // Formular auf derselben Seite statt auf /kontakt: der Seitenwechsel kostet
  // dort einen Schritt und den Kampagnenkontext.
  const [hasInlineForm, setHasInlineForm] = useState(false)

  useEffect(() => {
    setHasInlineForm(Boolean(document.getElementById('anfrage')))
  }, [pathname])

  if (pathname.includes('/kontakt')) return null

  const content = (
    <>
      <IconArrowRight size={24} className="hidden lg:inline" />
      <IconMail size={20} className="lg:hidden" />
      {/* Label war mobil ausgeblendet, der Tab zeigte dort nur ein nacktes Icon
          ohne erkennbare Funktion. */}
      <span>{t('startProject')}</span>
      <span className="sr-only">{t('getInTouch')}</span>
    </>
  )

  return hasInlineForm ? (
    <a href="#anfrage" className={linkClassName}>
      {content}
    </a>
  ) : (
    <Link href="/kontakt" className={linkClassName}>
      {content}
    </Link>
  )
}

export default CTAContactLink
